/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconProtractorTool = ({ fillColor, ...props }) => (
  <SVG
    width="35"
    height="25"
    viewBox="0 0 35 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.43 0.5C21.779 0.503549 25.959 2.18453 29.0997 5.1929C32.2403 8.20128 34.0995 12.3052 34.29 16.65V24.24H32.55V20.24H31.45V24.24H28.38V21.69H27.28V24.23H24.22V20.23H23.12V24.23H20.05V21.69H18.95V24.23H15.88V20.23H14.78V24.23H11.72V21.69H10.62V24.23H7.55V20.23H6.45V24.23H3.31V21.69H2.21V24.23H0.45V16.65C0.670741 12.292 2.5588 8.1858 5.72331 5.18137C8.88782 2.17695 13.0864 0.504413 17.45 0.51M8.3 16.65H26.56C26.3599 14.3679 25.312 12.2435 23.6228 10.696C21.9336 9.14841 19.7259 8.28998 17.435 8.28998C15.1441 8.28998 12.9364 9.14841 11.2472 10.696C9.55803 12.2435 8.51007 14.3679 8.31 16.65M17.44 0.0100002C13.0326 0.00243592 8.78549 1.66195 5.55079 4.65553C2.31609 7.64911 0.333196 11.7553 0 16.15V16.65V24.74H2.76V22.19H2.86V24.73H6.99V20.73H7.09V24.73H11.15V22.19H11.25V24.73H15.28V20.73H15.38V24.73H19.44V22.19H19.54V24.73H23.6V20.73H23.7V24.73H27.78V22.19H27.88V24.73H31.94V20.73H32.04V24.73H34.8V16.15H34.75C34.4368 11.7682 32.4767 7.66723 29.2638 4.67132C26.0508 1.6754 21.823 0.0065013 17.43 0L17.44 0.0100002ZM8.87 16.15C9.18357 14.1045 10.2192 12.239 11.7895 10.8911C13.3597 9.54327 15.3606 8.80225 17.43 8.80225C19.4994 8.80225 21.5003 9.54327 23.0705 10.8911C24.6408 12.239 25.6764 14.1045 25.99 16.15H8.87Z"
      fill={fillColor || 'white'}
    />
  </SVG>
)

export default withIconStyles(IconProtractorTool)
